module.exports = __webpack_public_path__ + "img/logo-200x200.c36f02d6.png";